import vueRouter from 'vue-router';
import Routes from './Routes';
import { get as getCookie } from 'es-cookie';
var router = new vueRouter({
    routes: Routes,
    mode: 'history',
    scrollBehavior: function (to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        }
        if (to.hash) {
            return {
                selector: to.hash,
            };
        }
        return { x: 0, y: 0 };
    },
});
router.beforeEach(function (to, from, next) {
    var defaultTitle = 'The HUB by the Adventure Travel Trade Association';
    // Add title tag if in meta
    if (to.meta && to.meta.title && to.meta.title !== '') {
        document.title = to.meta.title + ' | ' + defaultTitle;
    }
    else {
        document.title = defaultTitle;
    }
    // Close mobile nav if open during route change
    if (document.getElementsByTagName('html')[0].classList
        && document.getElementsByTagName('html')[0].classList.contains('nav-open')) {
        document.getElementsByTagName('html')[0].classList.remove('nav-open');
    }
    // Require auth
    if (to.matched.some(function (record) { return record.meta.requiresAuth; })) {
        // If there is no access token set, redirect to login page
        // This will not catch invalid tokens but will catch any users without a set token
        // Invalid tokens will get caught by API requests and 401 logout scripts
        if (!getCookie('atta_token')) {
            var newLocation = appConfig.myAccountUrl + "/login";
            newLocation += "?redirect=" + encodeURIComponent(window.location.href);
            window.location.href = newLocation;
            /*next({
              path: '/login',
              query: { redirect: encodeURIComponent(to.path) },
            });*/
            return;
        }
    }
    next();
});
export default router;



// WEBPACK FOOTER //
// ./~/ts-loader??ref--3!./src/js/Router/index.ts